import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'wsm-error-boundary';
import DetailedSpecs from '../components/DetailedSpecs';

const WidgetContainer = (props) => {
	let rootComponent;
	if (props.equipment) {
		const { specCategories, specification } = props.equipment;
		const { prefs, widgetInfo } = props;

		rootComponent = (
			<ErrorBoundary newRelicPageAction="WS DETAILED SPECS ERROR BOUNDARY">
				<DetailedSpecs
					specCategories={specCategories}
					specification={specification}
					widgetInfo={widgetInfo}
					prefs={prefs}
				/>
			</ErrorBoundary>
		);
	}
	return rootComponent;
};

WidgetContainer.propTypes = {
	equipment: PropTypes.shape({
		specCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
		specification: PropTypes.arrayOf(PropTypes.object).isRequired
	}),
	prefs: PropTypes.objectOf(PropTypes.string),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

WidgetContainer.defaultProps = {
	equipment: {},
	prefs: {}
};

const mapStateToProps = (state) => ({
	prefs: state.prefs,
	equipment: state.equipment,
	widgetInfo: state.widgetInfo
});

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
